import { render, staticRenderFns } from "./FccTipoContasBancarias.vue?vue&type=template&id=65abaa31"
import script from "./FccTipoContasBancarias.vue?vue&type=script&lang=js"
export * from "./FccTipoContasBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports